export const selectInseminations = state => state.insemination.inseminations
export const selectCurrentInsemination = state => state.insemination.currentInsemination
export const selectBlockInsemination = state => state.insemination.blockInsemination
